export const i18nMessages = {
  error: {
    title: 'Ops..',
    message: 'Algo salió mal, por favor intente nuevamente.',
  },
  fetch_error: {
    title: 'Something went wrong...',
    message: 'Please, try again or contact support',
  },
  unauthorized: {
    title: 'No autorizado',
    message: 'No tienes permiso para esta acción.',
  },
  success: {
    title: '¡Éxito!',
    message: 'La operación se realizó con éxito.',
  },
  info: {
    title: 'Ok',
    message: 'Operación realizada.',
  },
  warning: {
    title: 'Atención',
    message: 'Algo no salió como se esperaba.',
  },
  create: {
    title: '¡Éxito!',
    message: 'Nuevo desvío de condición creado con éxito.',
  },
  edit: {
    title: '¡Éxito!',
    message: 'Mudanzas aplicadas con éxito.',
  },
  conflict: {
    title: 'Ops..',
    message: 'Hubo un conflicto al realizar la operación, intente nuevamente.',
  },
  model_not_found: {
    title: 'Modelo no encontrado.',
    message: 'Algo salió mal, por favor intente nuevamente.',
  },
  server_error: {
    title: 'Ops..',
    message: 'Error interno del servidor.',
  },
  validation_error: {
    title: 'Error de validación',
    message:
      'Hubo un error de validación al realizar la operación, verifique los datos, luego intente nuevamente.',
  },
  auth_error: {
    title: 'Ops..',
    message:
      'Ocurrió un error durante el paso de autenticación. Espera unos minutos e inténtalo de nuevo',
  },
  '404': {
    title: 'Página no encontrada',
    message: 'Intente volver a la página anterior o comuníquese con el soporte técnico de Shape.',
    action: 'Ir a la página de inicio',
  },
  new_event_alert: {
    title: 'Nuevo Evento',
    message: 'Se creó el evento {{eventId}} para el equipo {{asset}}',
  },
  form_error: {
    title: 'Ops..',
    message:
      'Lo sentimos, no se puede guardar porque faltan algunos campos o son incorrectos. Por favor, compruebe los siguientes elementos antes de guardar.',
    required: 'se requiere',
    special_character: 'No se permiten caracteres especiales',
  },
  workspaceError: {
    title: 'Error',
    message: 'Su usuario no tiene un workspace registrado',
  },
  no_data: {
    title: 'No hay datos',
    message: 'No hay datos para mostrar',
  },
  copied_id_success: {
    message: 'ID copiada',
  },
  api_errors: {
    403: {
      title: 'Error de permiso',
      message: 'No tiene permiso para acceder a la información relacionada con este activo',
    },
  },
  prevent_edit_leave: {
    title: 'Salir sin guardar?',
    message: 'Algunos campos en esta página fueron editados. Si continúa, estos datos se perderán',
    confirmLabel: 'Si, salga',
    cancelLabel: 'Cancelar',
  },
};
